<template>
  <div>
    <!-- 본문 -->
    <v-sheet class="pt-4 mx-auto">
      <!-- 내 사진 내역 없을 시 -->
      <v-sheet v-if="!list.length" class="rounded-10 pt-8 text-center text-subtitle-1 primary--text">
        <v-icon size="40" color="primary" class="mb-2">mdi-cancel</v-icon><br />
        내 사진 내역이 없습니다
      </v-sheet>

      <!-- 내 사진 내역 있을 시 -->
      <v-sheet v-if="list.length" class="py-1">
        <v-row no-gutters>
          <v-col v-for="item in list" :key="item.filename" cols="4" style="border: 1px solid white; cursor: pointer">
            <v-img width="100%" aspect-ratio="0.8" :src="item.thumbnailUrl" @click="openDownload(item)" :gradient="item.completeStatus == '완료예정' ? 'rgba(92,92,92,.8),rgba(92,92,92,.8)' : ''">
              <div class="sela-bottom-caption d-flex justify-center align-center" :class="item.status != 2 ? 'disabled' : ''">
                <div style="color: white; position: absolute; bottom: 8px; font-size: 0.8rem; text-align: center">
                  {{ item.title }}
                  <br />
                  {{ item.completeStatus }} {{ item.completeStatus !== "완료" ? item.completeDate : "" }}
                </div>
              </div>
            </v-img>
          </v-col>
        </v-row>
      </v-sheet>
    </v-sheet>
    <MyPictureDialog v-if="showDialog" :visible="showDialog" :key="selected_item.id" :item="selected_item" @close="showDialog = false" />
  </div>
</template>
<script>
import MyPictureDialog from "./MyPictureDialog"

export default {
  components: {
    MyPictureDialog,
  },

  data: () => ({
    list: [],

    selected_item: null,

    showDialog: false,
  }),

  mounted() {
    this.load()
  },

  methods: {
    load() {
      this.$http
        .post("/api/request/select/byUser", {
          params: {
            user_id: this.$store.state.lafia_user.user_id,
          },
        })
        .then((res) => {
          const newList = []

          res.data.forEach((item) => {
            newList.push({
              ...item,
              thumbnailUrl: item.status == 2 ? this.$imageUrl(item.complete_url.replace(".jpg", "_thumbnail.jpg")) : this.$imageUrl("/upload/auto_photo/resized/" + item.filename),
              imageUrl: item.status == 2 ? this.$imageUrl(item.complete_url) : this.$imageUrl("/upload/auto_photo/selected/" + item.filename),
              completeDate: this.$getTDaysLater(item.complete_date || item.created, 3, true),
              completeStatus: item.status == 2 ? "완료" : "완료예정",
            })
          })
          this.list = newList.reverse()
        })
    },

    openDownload(item) {
      this.selected_item = item
      this.showDialog = true
    },
  },
}
</script>
<style scoped></style>
